import { render, staticRenderFns } from "./MsalCallback.vue?vue&type=template&id=1896dcd2&scoped=true&"
import script from "./MsalCallback.vue?vue&type=script&lang=ts&"
export * from "./MsalCallback.vue?vue&type=script&lang=ts&"
import style0 from "./MsalCallback.vue?vue&type=style&index=0&id=1896dcd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1896dcd2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VMain } from 'vuetify/lib/components/VMain';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VImg,VMain,VRow})
